import React from "react";
import PropTypes from "prop-types";

import "./RefundQuestionnaire.sass";

function RefundQuestionnaire({ title, name, handleValue, errorMsg, ...rest }) {
  return (
    <div
      className={`questionnaire__block  ${
        errorMsg !== "" ? "questionnaire__block--error" : ""
      }`}
      {...rest}
    >
      <p className="questionnaire__block-title">
        {title} <span className={errorMsg !== "" ? "error" : ""}>*</span>
      </p>
      <div className="inputs">
        <div className="inputs__wrapper">
          <input
            type="radio"
            name={name}
            id={`${name}_yes`}
            value="yes"
            onChange={handleValue}
          />
          <label htmlFor={`${name}_yes`}>Yes</label>
        </div>
        <div className="inputs__wrapper">
          <input
            type="radio"
            name={name}
            id={`${name}_no`}
            value="no"
            onChange={handleValue}
          />
          <label htmlFor={`${name}_no`}>No</label>
        </div>
      </div>{" "}
      {errorMsg !== "" && <span className="field__error">{errorMsg}</span>}
    </div>
  );
}

RefundQuestionnaire.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  handleValue: PropTypes.func.isRequired,
  errorMsg: PropTypes.string,
};
RefundQuestionnaire.defaultProps = {
  errorMsg: "",
};

export default RefundQuestionnaire;
